import { InstallationInvitationModel } from 'src/Libs/installation-rights-management/models'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import useModals from 'src/Hooks/useModals'
import { useCallback } from 'react'

interface UseAccessInvitationHook {
  resend: () => Promise<InstallationInvitationModel>
}

/**
 * Provides the dialog and callback processes to re-send an invitation to an Installation
 * @param item
 */
const useAccessInvitationDialog = (item: InstallationInvitationModel): UseAccessInvitationHook => {
  const { t } = useCustomTranslation()
  const { openConfirmationModal } = useModals()

  const resend = useCallback(async (): Promise<InstallationInvitationModel> => {
    return new Promise(resolve => {
      const onConfirm = (close: () => void): void => {
        resolve(item)
        close()
      }

      openConfirmationModal({
        text: t('installation.access-and-invitations.resend.dialog.description', { email: item?.accountId }),
        buttonText: [t('common.cancel'), t('common.ok')],
        onConfirm: onConfirm,
        title: t('installation.access-and-invitations.resend.dialog.title'),
      })
    })
  }, [item, openConfirmationModal, t])

  return { resend }
}

export default useAccessInvitationDialog
